import axios from "../../axios";

export const getCountriesWithCoordinates = async () => {
  const { data } = await axios.get("/countries/v1");
  return data;
};
